import React from 'react';
import './RadioButton.scss';

interface RadioButtonProps {
  changed: (e: string) => void;
  value: string;
  isSelected?: boolean;
  label: string;
  name: string;
}

interface RadioButtonGroupProps {
  legend: string;
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  changed,
  value,
  isSelected,
  label,
  name
}) => {
  const randomNumber = Math.ceil(Math.random() * 1000) * Date.now();

  const handleChange = (e: any, fn: (e: string) => void) => {
    if (e.nativeEvent.type === 'click') {
      fn(e.target.value);
    }
  };

  return (
    <div className="ads-radio-button" data-testid="ads-radio-button">
      <span className="ads-radio-button__container">
        <input
          id={`ads-checkbox--${randomNumber}`}
          onChange={(e) => handleChange(e, changed)}
          value={value}
          type="radio"
          checked={isSelected}
          name={name}
          aria-checked={isSelected}
          className="ads-radio-button__input"
          tabIndex={0}
          data-testid="ads-radio-button__input"
        />
        <label
          htmlFor={`ads-checkbox--${randomNumber}`}
          className="ads-radio-button__label"
          data-testid="ads-radio-button__label"
        >
          {label}
        </label>
        <div className="ads-radio-button__focus" />
      </span>
    </div>
  );
};

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  children,
  legend
}) => {
  return (
    <fieldset
      className="ads-radio-button-group"
      data-testid="ads-radio-button-group"
    >
      <legend>{legend}</legend>
      {children}
    </fieldset>
  );
};
